import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public sidebarCollapsed: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.sidebarCollapsed = localStorage.getItem("hanui.sidebarCollapsed") === "1";
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public async setSidebarCollapsed(collapsed: boolean) {
        this.sidebarCollapsed = collapsed === true;
        localStorage.setItem("hanui.sidebarCollapsed", this.sidebarCollapsed ? "1" : "0");
        await this.service.render();
    }
}

export default LayoutSidebarComponent;